import { useEffect, useState, useCallback } from "react";
import { getSocialLinksRaw, getSocialLinks as fetchSocialLinks } from "../utils/getSocialLinks";

export function useSocialLinks(allowedPlatforms = ['facebook', 'instagram', 'youtube']) {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [errorStatus, setErrorStatus] = useState(null);
    const [errorBody, setErrorBody] = useState(null);
    const [errorEndpoint, setErrorEndpoint] = useState(null);
    const [raw, setRaw] = useState(null);
    const [endpoint, setEndpoint] = useState(null);

    const allowedKey = JSON.stringify(allowedPlatforms || []);

    const fetchLinks = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            console.debug('useSocialLinks: fetching allowedPlatforms=', allowedPlatforms);
            const res = await getSocialLinksRaw(allowedPlatforms);
            console.debug('useSocialLinks: fetch result', res);
            const dataToSet = res?.filteredLinks || res?.links || [];
            console.debug('useSocialLinks: dataToSet', dataToSet);
            setData(dataToSet);
            setRaw(res?.raw);
            setEndpoint(res?.endpoint);
        } catch (err) {
            console.error('useSocialLinks fetch error', err);
            setData([]);
            setError(err?.message || 'Failed to fetch social links');
            setErrorStatus(err?.status || null);
            setErrorBody(err?.bodySnippet || null);
            setErrorEndpoint(err?.endpoint || null);
        } finally {
            setLoading(false);
        }
    }, [allowedPlatforms]);

    useEffect(() => {
        fetchLinks();
    }, [fetchLinks, JSON.stringify(allowedPlatforms || [])]);

    const refresh = useCallback(() => fetchLinks(), [fetchLinks]);

    return { data, loading, error, errorStatus, errorBody, errorEndpoint, raw, endpoint, refresh };
}

// For convenience, keep a promise-based exported function
export async function getSocialLinks() {
    return await fetchSocialLinks();
}

export default useSocialLinks;
